import React, { useEffect, useState } from 'react';
import styles from "./styles.module.scss";
import { getStudentId, submitConsent } from '../../store/actions/student.action';
import { useDispatch, useSelector } from 'react-redux';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { uploadStudentFile } from '../../constants/api/GraphApi/uploadFile';
import { getAccessToekn } from '../../store/actions/auth.action';
import { getConsentFile } from '../../constants/api/GraphApi/getconsentPDF';
import { useMsal } from '@azure/msal-react';
import axios from 'axios';

const ConsentForm = () => {
    const {accounts} = useMsal()
    const accessToken = useSelector((state) => state.authReducers?.getAcessToken?.token?.token)
    //get Student id from reducer
    const getApplicantID = useSelector(
        (state) =>
            state.studentReducers?.getStudentId?.data?.data?.techoon_applicantid
    );
    const user_name = useSelector(
        (state) => state.studentReducers?.getStudentId?.data?.data
    );
    const first_name = user_name?.firstname;
    const middle_name = user_name?.middlename;
    const last_name = user_name?.lastname;
    const [permissionStatus, setPermissionStatus] = useState(null);
    const [location, setLocation] = useState(null);
    const [error, setError] = useState(null);
    const [studentName, setStudentName] = useState();
    const [StudentId, setStudentId] = useState();
    const [fileUploaded, setFileuploaded] = useState();
    const [loadingActive, setloadingActive] = useState();
    const [errorFromSP, setErrorfromsp] = useState();
    const [consentFile, setConsentFile] = useState();
    const [ip,setIp] = useState("")
    //request call for the student id
    useEffect(() => {
        dispatch(getAccessToekn.request());
        setloadingActive(true);
    }, [])

    //get the file from sharepoint
    useEffect(() => {
        const getFile = async () => {
            const path = 'DummyPdf'
            const getFiles = await getConsentFile(path, accessToken)
            setConsentFile(getFiles);
        }
        accessToken && getFile()
    }, [accessToken])
    //set the student id in local storage
    useEffect(() => {
        const Student_Name = [
            first_name?.trim(),
            middle_name !== null ? middle_name?.trim() : middle_name,
            last_name?.trim(),
        ]
            .filter(Boolean)
            .join(" ");
        setStudentName(Student_Name);
        setStudentId(getApplicantID);
    }, [getApplicantID, first_name, middle_name, last_name]);


    useEffect(() => {
        const checkGeolocationPermission = () => {
            if (!("geolocation" in navigator)) {
                setPermissionStatus("Geolocation is not supported by this browser.");
                return;
            }

            navigator.geolocation.getCurrentPosition(
                (position) => {
                    setPermissionStatus("Permission granted");
                    setLocation({
                        latitude: position.coords.latitude,
                        longitude: position.coords.longitude,
                    });
                },
                (error) => {
                    if (error.code === error.PERMISSION_DENIED) {
                        setPermissionStatus("Permission denied");
                    } else {
                        setError("Error retrieving location");
                    }
                }
            );
        };

        checkGeolocationPermission();
    }, []);

    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getAccessToekn.request());
        const payloadData = {
            official_email : accounts[0].username
        }
        dispatch(getStudentId.request(payloadData));
        const   fetchIp = async() => {
            const ipResponse = await axios.get('https://api.ipify.org?format=json');
            if(ipResponse?.data?.ip){
                setIp(ipResponse?.data?.ip)
        }
    }
    fetchIp()
}, [])
    const [isCheckedList, setIsCheckedList] = useState([]);

// console.log("ip", ip)

    const data = [
        {
            heading: "1. Consent to Share",
            content: [
                { id: "1", content: "I agree that information regarding my individual support needs (including medical, mental health and learning needs) can be shared with GIS academic and support staff, external agencies, employers, and placement contracts on a need-to-know basis." },
                { id: "2", content: "I agree that information regarding my individual support needs (including medical, mental health and learning needs) can be shared with my nominated emergency contact(s)." },
                { id: "3", content: "I understand that if I refuse consent, information regarding my individual support needs (including medical, mental health and learning needs) will be kept on record by the Student Support Team but will not be shared with my nominated emergency contact(s)." }
            ],
            isCheckboxRequired: true
        },
        {
            heading: "2. Generic Consent",
            content: [
                {
                    id: "4",
                    content: "I agree to the terms of the GIS ",
                    link: {
                        text: "Privacy Policy",
                        url: "https://gis.sport/about/policies/privacy-policy/"
                    },
                    afterLink: " and am happy to be contacted by GIS in relation to this application"
                }
            ],
            isCheckboxRequired: true
        },
        {
            heading: "3. Marketing Consent",
            content: [
                {
                    id: "5",
                    content: `GIS would like to inform you about academic courses and professional education opportunities that we believe may be of interest to you. By ticking "I agree" you are confirming you wish to receive these emails.`,
                    afterCheckbox: `Should you change your mind and wish to stop receiving these communications, this can be requested by emailing `,
                    email: "admissions@gis.sport"
                }
            ],
            isCheckboxRequired: true
        },
        {
            heading: "4. University of East London (UEL) Student Enrolment Declaration",
            content: [
                {
                    id: "6",
                    content: `If you are studying a degree validated by the University of East London (UEL), please take a moment to read and agree to the University of East London General and Student Policies.`,
                    links: [
                        {
                            berforeText: "For General Policies go here: ",
                            text: "https://www.uel.ac.uk/about/about-uel/governance/policies-regulations-corporate-documents/general-policies",
                            url: "https://www.uel.ac.uk/about/about-uel/governance/policies-regulations-corporate-documents/general-policies"
                        },
                        {
                            berforeText: "For Student Policies go here: ",
                            text: "https://www.uel.ac.uk/about/about-uel/governance/policies-regulations-corporate-documents/student-policies",
                            url: "https://www.uel.ac.uk/about/about-uel/governance/policies-regulations-corporate-documents/student-policies"
                        }
                    ]
                }
            ],
            isCheckboxRequired: false
        },
        {
            heading: "5. Social Media Policy",
            content: [
                {
                    id: "7", content: "Please tick to confirm that you have read and understand the GIS social media policy at ",
                    link: {
                        text: "Social  Media Policy",
                        url: "https://view.officeapps.live.com/op/view.aspx?src=https%3A%2F%2Fwww.ucfb.ac.uk%2Fmedia%2F9335%2Fgis-social-media-policy-aug-2024-v1-1.docx&wdOrigin=BROWSELINK"
                    }
                },
            ],
            isCheckboxRequired: true
        },
        {
            heading: "6. Promotion/Publicity Permission",
            content: [
                {
                    id: "8", content: "Please tick to confirm that you have read, understand, and agree to GIS’s use of ",
                    link: {
                        text: "images for promotional purposes",
                        url: "https://view.officeapps.live.com/op/view.aspx?src=https%3A%2F%2Fwww.ucfb.ac.uk%2Fmedia%2F9334%2Fgis-promotion-publicity-permission-1.docx&wdOrigin=BROWSELINK"
                    },
                    afterLink: ", if you are undertaking any in person activity or attending on campus events arranged by GIS or its partners"
                },
            ],
            isCheckboxRequired: true
        },
        {
            heading: "7. GIS Disclaimer",
            content: [
                {
                    id: "9",
                    heading: "7.1 Disclaimer for personal injury or death",
                    content: `Whilst utilising GIS campus locations or undertaking on site residential activity or other associated in person events, please note that all sporting and physical activities are physically challenging and carry with them risks that we cannot entirely eliminate. These include the risk of personal injuries.`,
                    listItems: [
                        "You must act responsibly and sensibly at all times.",
                        "You must not participate in physical activity if you are pregnant or under the influence of alcohol or non-prescription drugs.",
                        "You must follow any safety warnings or instructions displayed or given to you by a member of staff. Ask a member of staff if you are unclear.",
                        "We are not qualified to express an opinion that you are fit to safely participate. You must obtain professional or specialist advice from your doctor before participating.",
                        "Sport and physical activities may be undertaken without direct supervision by a member of staff. You must ensure you wear any appropriate and necessary protective equipment. You are responsible for using the equipment safely. You must behave sensibly and follow any safety instructions so as not to hurt or injure yourself or others. You must check such equipment prior to use and report any faults, damage or concerns to a member of staff. You must also check the facilities prior to use and report any faults, damage or concerns to a member of staff.",
                        "In the absence of any negligence or other breach of duty by us, the use of our equipment and facilities is entirely at your own risk.",
                        "In the absence of any negligence or other breach of duty by us, participation in all sporting and physical activities is entirely at your risk."
                    ],
                    moreContent: [
                        {
                            id: "10",
                            heading: "7.2 Disclaimer for loss or damage to property",
                            content: `In the absence of any negligence or other breach of duty by us, we are not responsible for any theft, damage, destruction or loss of your property or belongings while using our facilities.`,
                            afterContent: `It is important that you read and understand this statement before accepting. If there is any term that you do not understand, then do not click “I agree” and contact `,
                            email: "admissions@gis.sport"
                        }
                    ]
                }
            ],
            isCheckboxRequired: true
        }
    ];

    const allContentIds = data.flatMap(item => item.content.map(contentItem => contentItem.id));
    const allChecked = (allContentIds.length - 1) === isCheckedList.length;

    const handleCheckboxChange = (id) => {
        setIsCheckedList(prevState =>
            prevState.includes(id)
                ? prevState.filter(item => item !== id)
                : [...prevState, id]
        );
    };

    const handleSubmit = () => {
        localStorage.setItem("consent-form", "submit")
        const payload = {
            location_access: false,
            official_email:accounts[0].username,
            ip:ip
        };
        if (permissionStatus === "Permission granted") {
            payload.location_access = true;
        }
        handleExportAndUpload();
        dispatch(submitConsent.request(payload));
    };

    //get first letter
    const getFirstLetterOfFirstWord = (name) => {
        const trimmedName = name?.trim();
        return trimmedName?.[0] ? trimmedName[0] : ''
    };
    let activeType = 'Consent'
    let first_letter_of_name = getFirstLetterOfFirstWord(studentName)
    const path = `${first_letter_of_name}/${studentName} - ${getApplicantID}`

    const handleExportAndUpload = async () => {
        const pdfName = 'Consent Form.pdf'
        await uploadStudentFile(consentFile, pdfName, path, activeType, StudentId, setErrorfromsp, setloadingActive, setFileuploaded, accessToken)
    };

    return (
        <>
            <div className={styles.mainHeading}>Consent Form</div>
            <div className={styles.consentFormContainer} id="pdf-content">
                <div className={styles.consentForm}>
                    {data.map((item, index) => (
                        <div key={index} className={styles.box}>
                            <h3 className={styles.heading}>{item.heading}</h3>
                            {item.content.map((contentItem, contentIndex) => (
                                <div key={contentItem.id} className={styles.boxContent}>
                                    {contentItem.heading ? <h5>{contentItem.heading}</h5> : ""}
                                    <p>
                                        {contentItem.content}
                                        {contentItem.link && (
                                            <a
                                                href={contentItem.link.url}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className={styles.privacyLink}
                                            >
                                                {contentItem.link.text}
                                            </a>
                                        )}
                                        {contentItem.afterLink && (
                                            <span>{contentItem.afterLink}</span>
                                        )}
                                    </p>
                                    {contentItem.afterContent && (
                                        <p>
                                            {contentItem.afterContent}
                                            <a href={`mailto:${contentItem.email}`} className={styles.emailLink}>
                                                {contentItem.email}
                                            </a>
                                        </p>
                                    )}
                                    {contentItem.links?.map((link, idx) => (
                                        <p key={idx}>
                                            {link.berforeText}
                                            <a
                                                href={link.url}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className={styles.privacyLink}
                                            >
                                                {link.text}
                                            </a>
                                        </p>
                                    ))}
                                    {contentItem.listItems && (
                                        <ul>
                                            {contentItem.listItems.map((listItem, idx) => (
                                                <li key={idx}>{listItem}</li>
                                            ))}
                                        </ul>
                                    )}
                                    {contentItem.moreContent?.map((moreContentItem) => (
                                        <div className={styles.moreContent}>
                                            {moreContentItem.heading ? <h5>{moreContentItem.heading}</h5> : ""}
                                            < p >
                                                {moreContentItem.content}
                                            </p>
                                            {moreContentItem.afterContent && (
                                                <p>
                                                    {moreContentItem.afterContent}
                                                    <a href={`mailto:${moreContentItem.email}`} className={styles.emailLink}>
                                                        {moreContentItem.email}
                                                    </a>
                                                </p>
                                            )}
                                        </div>
                                    ))}
                                    {item.isCheckboxRequired && <div className={styles.termConditonBox}>
                                        <input
                                            type="checkbox"
                                            id={`termsCheckbox-${contentItem.id}`}
                                            className={styles.checkbox}
                                            onChange={() => handleCheckboxChange(contentItem.id)}
                                        />
                                        <label
                                            htmlFor={`termsCheckbox-${contentItem.id}`}
                                            className={styles.customCheckbox}
                                        ></label>
                                        <label htmlFor={`termsCheckbox-${contentItem.id}`} className={styles.text}>
                                            I Agree
                                        </label>
                                    </div>}
                                    {contentItem.afterCheckbox && (
                                        <p>
                                            {contentItem.afterCheckbox}
                                            <a href={`mailto:${contentItem.email}`} className={styles.emailLink}>
                                                {contentItem.email}
                                            </a>
                                        </p>
                                    )}
                                </div>
                            ))}
                        </div>
                    ))}

                </div>
            </div >
            <div className={allChecked ? styles.button : styles.disableButton} onClick={allChecked ? handleSubmit : undefined}>Submit</div>
        </>
    );
};

export default ConsentForm;
